import React, { useState } from 'react';
import { PhoneIcon, MenuIcon, XIcon, ChevronDownIcon } from 'lucide-react';
export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isServicesOpen, setIsServicesOpen] = useState(false);
  const [mobileServicesOpen, setMobileServicesOpen] = useState(false);
  const [mobileGroup1Open, setMobileGroup1Open] = useState(false);
  const [mobileGroup2Open, setMobileGroup2Open] = useState(false);
  const [mobileGroup3Open, setMobileGroup3Open] = useState(false);
  const [mobileGroup4Open, setMobileGroup4Open] = useState(false);
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    setMobileServicesOpen(false);
    setMobileGroup1Open(false);
    setMobileGroup2Open(false);
    setMobileGroup3Open(false);
    setMobileGroup4Open(false);
  };
  const servicesGroups = [{
    heading: 'Vehicle Repair & Maintenance',
    links: [{
      label: 'Auto Repair Services',
      href: '#auto-repair'
    }, {
      label: 'Truck Repair Services',
      href: '#truck-repair'
    }, {
      label: 'Basic Car & Truck Maintenance',
      href: '#basic-maintenance'
    }, {
      label: 'Oil Change for Life',
      href: '#oil-change'
    }, {
      label: "Garrett's Reminder Service",
      href: '#reminder-service'
    }]
  }, {
    heading: 'Diesel & Medium-Duty Truck Repair',
    links: [{
      label: 'Power Stroke',
      href: '#power-stroke'
    }, {
      label: '7.3L Gas Engine',
      href: '#gas-engine'
    }, {
      label: 'Isuzu Truck Repair',
      href: '#isuzu-repair'
    }, {
      label: 'Drive Shaft Repair',
      href: '#drive-shaft'
    }, {
      label: 'Medium-Duty Truck Repair',
      href: '#medium-duty'
    }]
  }, {
    heading: 'Commercial Fleet Services',
    links: [{
      label: 'Fleet Maintenance Program',
      href: '#fleet-maintenance'
    }, {
      label: 'DOT Inspections',
      href: '#dot-inspections'
    }, {
      label: 'Annual DOT Inspections',
      href: '#annual-dot'
    }, {
      label: 'CDL Training Vehicle Inspections',
      href: '#cdl-training'
    }, {
      label: 'DOT for Life',
      href: '#dot-for-life'
    }]
  }, {
    heading: 'Trailer, Equipment & Specialty Services',
    links: [{
      label: 'Trailer Repair',
      href: '#trailer-repair'
    }, {
      label: 'Motor Home Repair',
      href: '#motor-home'
    }, {
      label: 'Equipment Repainting',
      href: '#equipment-repainting'
    }, {
      label: 'Roll-Up Door Parts',
      href: '#door-parts'
    }, {
      label: 'Farm Equipment Repair',
      href: '#farm-equipment'
    }]
  }];
  return <header className="bg-[#B1050B] text-white shadow-lg sticky top-0 z-50" data-id="element-221">
      <div className="container mx-auto px-4" data-id="element-222">
        <div className="flex justify-between items-center py-3" data-id="element-223">
          <div className="flex items-center" data-id="element-224">
            <img src="http://www.garrettauto.com/uploaded/images/MobileLogo/translogo.png" alt="Garrett Auto & Truck Repair" className="h-16 w-auto" data-id="element-225" />
          </div>
          <nav className="hidden lg:flex items-center justify-center space-x-8 flex-1" data-id="element-226">
            {/* Home */}
            <a href="#home" className="hover:text-red-200 transition-colors font-medium text-[17px]" data-id="element-227">
              Home
            </a>

            {/* About */}
            <a href="#about" className="hover:text-red-200 transition-colors font-medium text-[17px]" data-id="element-228">
              About
            </a>

            {/* Services Mega Menu */}
            <div className="relative" onMouseEnter={() => setIsServicesOpen(true)} onMouseLeave={() => setIsServicesOpen(false)} data-id="element-229">
              <button className="hover:text-red-200 transition-colors font-medium text-[17px] flex items-center" data-id="element-230">
                Services
                <ChevronDownIcon size={16} className="ml-1" data-id="element-231" />
              </button>

              {isServicesOpen && <div className="absolute top-full left-1/2 -translate-x-1/2 mt-2 bg-white text-gray-900 rounded-lg shadow-2xl border-2 border-black min-w-[900px] p-6" data-id="element-232">
                  <div className="grid grid-cols-2 gap-8" data-id="element-233">
                    {servicesGroups.map((group, index) => <div key={index} data-id="element-234">
                        <h4 className="font-bold text-[#B1050B] mb-3 text-base border-b-2 border-[#D4AF37] pb-2" data-id="element-235">
                          {group.heading}
                        </h4>
                        <ul className="space-y-2" data-id="element-236">
                          {group.links.map(link => <li key={link.href} data-id="element-237">
                              <a href={link.href} className="text-gray-700 hover:text-[#B1050B] transition-colors text-sm block py-1" data-id="element-238">
                                {link.label}
                              </a>
                            </li>)}
                        </ul>
                      </div>)}
                  </div>
                </div>}
            </div>

            {/* Contact */}
            <a href="#contact" className="hover:text-red-200 transition-colors font-medium text-[17px]" data-id="element-239">
              Contact
            </a>
          </nav>
          <div className="hidden lg:flex items-center" data-id="element-240">
            <a href="tel:2484788382" className="flex items-center bg-black hover:bg-gray-900 px-4 py-2 rounded font-medium transition-colors border-2 border-[#D4AF37] text-[17px]" data-id="element-241">
              <PhoneIcon size={18} className="mr-2" data-id="element-242" />
              <span data-id="element-243">(248) 478-8382</span>
            </a>
          </div>
          <button className="lg:hidden" onClick={toggleMenu} data-id="element-244">
            <MenuIcon size={36} data-id="element-245" />
          </button>
        </div>
      </div>
      {isMenuOpen && <div className="lg:hidden fixed inset-0 bg-[#B1050B] z-50 flex flex-col" data-id="element-246">
          <div className="container mx-auto px-4 py-4 flex justify-between items-center border-b border-red-800" data-id="element-247">
            <img src="http://www.garrettauto.com/uploaded/images/MobileLogo/translogo.png" alt="Garrett Auto & Truck Repair" className="h-12 w-auto" data-id="element-248" />
            <button onClick={toggleMenu} data-id="element-249">
              <XIcon size={36} data-id="element-250" />
            </button>
          </div>
          <div className="flex flex-col items-center justify-start flex-grow overflow-y-auto py-8 px-8" data-id="element-251">
            {/* Home */}
            <a href="#home" className="hover:text-red-200 transition-colors font-medium text-xl py-3" onClick={toggleMenu} data-id="element-252">
              Home
            </a>

            {/* About */}
            <a href="#about" className="hover:text-red-200 transition-colors font-medium text-xl py-3" onClick={toggleMenu} data-id="element-253">
              About
            </a>

            {/* Services Mobile Mega Menu */}
            <div className="w-full" data-id="element-254">
              <button onClick={() => setMobileServicesOpen(!mobileServicesOpen)} className="w-full text-center hover:text-red-200 transition-colors font-medium text-xl py-3 flex items-center justify-center" data-id="element-255">
                Services
                <ChevronDownIcon size={20} className={`ml-2 transition-transform ${mobileServicesOpen ? 'rotate-180' : ''}`} data-id="element-256" />
              </button>
              {mobileServicesOpen && <div className="bg-red-900/30 rounded-lg p-4 mb-4 mt-2 w-full space-y-4" data-id="element-257">
                  {/* Group 1: Vehicle Repair & Maintenance */}
                  <div data-id="element-258">
                    <button onClick={() => setMobileGroup1Open(!mobileGroup1Open)} className="w-full text-left font-bold text-[#D4AF37] text-base border-b border-red-800 pb-2 flex items-center justify-between" data-id="element-259">
                      {servicesGroups[0].heading}
                      <ChevronDownIcon size={16} className={`transition-transform ${mobileGroup1Open ? 'rotate-180' : ''}`} data-id="element-260" />
                    </button>
                    {mobileGroup1Open && <ul className="space-y-2 ml-2 mt-2" data-id="element-261">
                        {servicesGroups[0].links.map(link => <li key={link.href} data-id="element-262">
                            <a href={link.href} className="text-red-100 hover:text-white transition-colors text-sm block py-1" onClick={toggleMenu} data-id="element-263">
                              {link.label}
                            </a>
                          </li>)}
                      </ul>}
                  </div>

                  {/* Group 2: Diesel & Medium-Duty Truck Repair */}
                  <div data-id="element-264">
                    <button onClick={() => setMobileGroup2Open(!mobileGroup2Open)} className="w-full text-left font-bold text-[#D4AF37] text-base border-b border-red-800 pb-2 flex items-center justify-between" data-id="element-265">
                      {servicesGroups[1].heading}
                      <ChevronDownIcon size={16} className={`transition-transform ${mobileGroup2Open ? 'rotate-180' : ''}`} data-id="element-266" />
                    </button>
                    {mobileGroup2Open && <ul className="space-y-2 ml-2 mt-2" data-id="element-267">
                        {servicesGroups[1].links.map(link => <li key={link.href} data-id="element-268">
                            <a href={link.href} className="text-red-100 hover:text-white transition-colors text-sm block py-1" onClick={toggleMenu} data-id="element-269">
                              {link.label}
                            </a>
                          </li>)}
                      </ul>}
                  </div>

                  {/* Group 3: Commercial Fleet Services */}
                  <div data-id="element-270">
                    <button onClick={() => setMobileGroup3Open(!mobileGroup3Open)} className="w-full text-left font-bold text-[#D4AF37] text-base border-b border-red-800 pb-2 flex items-center justify-between" data-id="element-271">
                      {servicesGroups[2].heading}
                      <ChevronDownIcon size={16} className={`transition-transform ${mobileGroup3Open ? 'rotate-180' : ''}`} data-id="element-272" />
                    </button>
                    {mobileGroup3Open && <ul className="space-y-2 ml-2 mt-2" data-id="element-273">
                        {servicesGroups[2].links.map(link => <li key={link.href} data-id="element-274">
                            <a href={link.href} className="text-red-100 hover:text-white transition-colors text-sm block py-1" onClick={toggleMenu} data-id="element-275">
                              {link.label}
                            </a>
                          </li>)}
                      </ul>}
                  </div>

                  {/* Group 4: Trailer, Equipment & Specialty Services */}
                  <div data-id="element-276">
                    <button onClick={() => setMobileGroup4Open(!mobileGroup4Open)} className="w-full text-left font-bold text-[#D4AF37] text-base border-b border-red-800 pb-2 flex items-center justify-between" data-id="element-277">
                      {servicesGroups[3].heading}
                      <ChevronDownIcon size={16} className={`transition-transform ${mobileGroup4Open ? 'rotate-180' : ''}`} data-id="element-278" />
                    </button>
                    {mobileGroup4Open && <ul className="space-y-2 ml-2 mt-2" data-id="element-279">
                        {servicesGroups[3].links.map(link => <li key={link.href} data-id="element-280">
                            <a href={link.href} className="text-red-100 hover:text-white transition-colors text-sm block py-1" onClick={toggleMenu} data-id="element-281">
                              {link.label}
                            </a>
                          </li>)}
                      </ul>}
                  </div>
                </div>}
            </div>

            {/* Contact */}
            <a href="#contact" className="hover:text-red-200 transition-colors font-medium text-xl py-3" onClick={toggleMenu} data-id="element-282">
              Contact
            </a>

            <a href="tel:2484788382" className="flex items-center bg-black hover:bg-gray-900 px-6 py-3 rounded font-medium transition-colors border-2 border-[#D4AF37] mt-6" data-id="element-283">
              <PhoneIcon size={18} className="mr-2" data-id="element-284" />
              <span data-id="element-285">(248) 478-8382</span>
            </a>
          </div>
        </div>}
    </header>;
}